import { Badge } from "@components/ui/badge";

type TemplateTypeBadgeProps = {
  isCustom: boolean;
};

export const TemplateTypeBadge = ({ isCustom }: TemplateTypeBadgeProps) => {
  const templateType = isCustom ? "Custom" : "System Default";
  const badgeVariant = isCustom ? "secondary" : "primary";

  return (
    <Badge variant={badgeVariant} className="px-2 py-0.5 text-[11px]">
      {templateType}
    </Badge>
  );
};
